import { createStyles, makeStyles, Theme, Box } from '@material-ui/core';
import { FC, useEffect } from 'react';
import { WePayTokenResponse } from '../custom-types/WePayTokenResponse';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cciFrame: {
      padding: `${theme.spacing(0)}px ${theme.spacing(2)}px`,
      minHeight: 65,
    },
  }),
);

interface WePayCreditCaptureProps {
  injectSuccess: (iframe: { tokenize: () => Promise<WePayTokenResponse> }) => void;
  iFrameId: string;
  setIsIframeVisible: (isIFrameVisible: boolean) => void;
}

const WePayCreditCapture: FC<WePayCreditCaptureProps> = props => {
  const classes = useStyles();
  const { injectSuccess, iFrameId, setIsIframeVisible } = props;
  let creditCardIframe: { tokenize: () => Promise<WePayTokenResponse> };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const wepay = (window as any).WePay;
  const injectWePayIFrame = () => {
    const div = document.getElementById(iFrameId);
    if (div && div.innerHTML) {
      return;
    }
    creditCardIframe = wepay.createCreditCardIframe(iFrameId, {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      custom_style: {
        styles: {
          base: {
            'border-radius': '4px',
            height: '56px',
            'font-size': '16px',
          },
          'expiration-slash': {
            base: {
              'font-size': '30px',
            },
          },
          'cvv-icon': {
            base: {
              display: 'none',
            },
          },
        },
      },
    });
    injectSuccess(creditCardIframe);
  };

  // Inject the iframe on initial render.
  useEffect(() => {
    injectWePayIFrame();

    //setting the onload event of iframe so, holder name will load with iframe
    const iframe = document.getElementById('cc_iframe_iframe');
    if (iframe) {
      iframe.onload = () => {
        setIsIframeVisible(true);
        const loadedIframe = document.getElementById('cc_iframe_iframe');
        if (loadedIframe) loadedIframe.style.minHeight = '136px';
      };
    }
  }, []);

  // Credit card iFrame docs
  // https://dev.wepay.com/docs/link-integration/process-payments#credit-card-iframes
  return <Box id={iFrameId} className={classes.cciFrame} />;
};

export default WePayCreditCapture;
